// extracted by mini-css-extract-plugin
export default {"scrollable":"Notifications_scrollable__Rvc9+","active":"Notifications_active__-d1IK","inactive":"Notifications_inactive__3VCz4"};